import { render, staticRenderFns } from "./partials.vue?vue&type=template&id=3f268aa6&"
import script from "./partials.vue?vue&type=script&lang=ts&"
export * from "./partials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports